import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const handleClick = () => setNav(!nav);
    const handleResize = () => {
        if (window.innerWidth >= 768) {
        setNav(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <nav
            className={`flex flex-row justify-between text-cyan-800 backdrop-blur-xl shadow-[0.8rem_0.8rem_1.125rem_0_rgb(225,226,228,0.5),-0.8rem_-0.8rem_1.125rem_0_rgb(255,255,255,0.5)] rounded-lg fixed w-full z-20 transition-all duration-500 ease-in-out
            ${nav ? 'h-screen md:pt-10' : 'h-20 md:top-10 md:left-1/2 md:h-fit md:transform md:-translate-x-1/2 md:w-3/4 md:rounded-lg'}`}>
            <div className="flex justify-center p-5 md:p-10">
                <h1 className="text-2xl font-bold">cam</h1>
            </div>
            <div className={`text-cyan-800 transition-all duration-500 ease-in-out text-4xl font-medium ${!nav ? 'hidden' : ''}`}>
                <ul>
                    <li>
                        <NavLink to="/" className={({ isActive }) =>
                        (isActive ? "block py-2 pl-3 pr-4 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 pl-3 pr-4 rounded hover:bg-slate-600")}
                        onClick={handleClick}
                        >home</NavLink> 
                    </li>
                    <li>
                        <NavLink to="/focus" className={({ isActive }) => 
                        (isActive ? "block py-2 pl-3 pr-4 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 pl-3 pr-4 rounded hover:bg-slate-600")}
                        onClick={handleClick}
                        >focus</NavLink>
                    </li>

                </ul>
            </div>
            {/*  */}
            <div className="max-w-screen-xl flex flex-wrap p-4">
                <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1">
                    <ul className="flex flex-row font-medium space-x-6">
                    <li>
                        <NavLink to="/" className={({ isActive }) =>
                        (isActive ? "block py-2 px-3 font-bold shadow-[0.3rem_0.3rem_0.4rem_0_rgb(225,226,228),-0.4rem_-0.4rem_1.0rem_0_rgb(255,255,255)] rounded" : "block py-2 px-3 rounded hover:shadow-[0.3rem_0.3rem_0.4rem_0_rgb(225,226,228),-0.4rem_-0.4rem_1.0rem_0_rgb(255,255,255)]")}>
                            Home</NavLink>
                    </li>
                    <li>
                        <NavLink to="/focus" className={({ isActive }) =>
                        (isActive ? "block py-2 px-3 font-bold shadow-[0.3rem_0.3rem_0.4rem_0_rgb(225,226,228),-0.4rem_-0.4rem_1.0rem_0_rgb(255,255,255)] rounded" : "block py-2 px-3 rounded hover:shadow-[0.3rem_0.3rem_0.4rem_0_rgb(225,226,228),-0.4rem_-0.4rem_1.0rem_0_rgb(255,255,255)]")}>
                            Focus</NavLink>
                    </li>
                    </ul>
                </div>
                <button
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-slate-800 md:hidden rounded-lg hover:bg-cyan-200 focus:ring-2 focus:ring-cyan-500 transition-all duration-400 ease-in-out"
                    onClick={handleClick}
                >{!nav ? <Bars3Icon className="h-5 w-5" /> : <XMarkIcon className="h-5 w-5"></XMarkIcon>}
                </button>
            </div>
        </nav>
    )
} 

export default Navbar;